var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect } from 'react';
import { Types } from '../../../../states/actions';
import { parseLendiConversationMember } from '../../../../utils';
import { parseLendiMessage } from '../../../../utils/parsers';
import { lendiBot } from '../../../../states/state';
var channelMembers = [];
/**
 * `useMembers` hook can be used to get members for Twilio Channel
 *
 * @param chatState
 * @param dispatch
 * @param sessionToken
 * @param apiBaseurl
 */
export function useMembers(chatState, dispatch) {
    var _this = this;
    var channel = chatState.channel, members = chatState.members, messages = chatState.messages;
    // When Channel changed, get members
    useEffect(function () {
        if (channel) {
            var getMembersAsync = function () { return __awaiter(_this, void 0, void 0, function () {
                var err_1, lendiMembers;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, channel.getParticipants()];
                        case 1:
                            channelMembers = _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            err_1 = _a.sent();
                            throw new Error("@lendi/chat: unable to get Twilio members: ".concat(err_1));
                        case 3: return [4 /*yield*/, Promise.all(channelMembers.map(function (member) { return __awaiter(_this, void 0, void 0, function () {
                                var userDescriptor;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, member.getUser()];
                                        case 1:
                                            userDescriptor = _a.sent();
                                            return [2 /*return*/, parseLendiConversationMember(member, userDescriptor)];
                                    }
                                });
                            }); }))];
                        case 4:
                            lendiMembers = _a.sent();
                            lendiMembers.push(lendiBot);
                            dispatch({
                                type: Types.UPDATE_MEMBERS,
                                payload: lendiMembers,
                            });
                            return [2 /*return*/];
                    }
                });
            }); };
            getMembersAsync();
        }
        else {
            dispatch({
                type: Types.UPDATE_MEMBERS,
                payload: [lendiBot],
            });
        }
    }, [channel]);
    // When channel or members change, update listener
    useEffect(function () {
        if (channel) {
            // Listen for members joining a channel
            channel.on('participantJoined', function (member) { return __awaiter(_this, void 0, void 0, function () {
                var userDescriptor, newLendiMember;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, member.getUser()];
                        case 1:
                            userDescriptor = _a.sent();
                            return [4 /*yield*/, parseLendiConversationMember(member, userDescriptor)];
                        case 2:
                            newLendiMember = _a.sent();
                            dispatch({
                                type: Types.UPDATE_MEMBERS,
                                payload: __spreadArray(__spreadArray([], members, true), [newLendiMember], false),
                            });
                            return [2 /*return*/];
                    }
                });
            }); });
            // Listen for members user info changing
            channel.on('participantUpdated', function (update) {
                var updatedMember = update.participant;
                update.updateReasons.forEach(function (reason) {
                    var _a;
                    if (reason === 'lastConsumedMessageIndex') {
                        var updatedLendiMembers = __spreadArray([], members, true); // 1. Make a shallow copy of the items
                        var memberIndex = members.findIndex(function (member) { return member.identity === updatedMember.identity; });
                        if (memberIndex !== -1) {
                            var updatedLendiMember = __assign(__assign({}, members[memberIndex]), { lastConsumedMessageIndex: (_a = updatedMember.lastReadMessageIndex) !== null && _a !== void 0 ? _a : 0 });
                            updatedLendiMembers[memberIndex] = updatedLendiMember; // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
                            dispatch({
                                type: Types.UPDATE_MEMBERS,
                                payload: updatedLendiMembers,
                            });
                        }
                    }
                    else if (reason === 'lastConsumptionTimestamp') {
                        // Do nothing
                    }
                    else {
                        // console.log('Member ', updatedMember, ' other update reason: ', reason);
                    }
                });
            });
            // Listen for members leaving a channel
            channel.on('participantLeft', function (member) {
                var membersLeft = members.filter(function (lendiMember) { return lendiMember.identity !== member.identity; });
                dispatch({
                    type: Types.UPDATE_MEMBERS,
                    payload: membersLeft,
                });
            });
            // Listen for members typing
            channel.on('typingStarted', function (member) {
                dispatch({
                    type: Types.TYPING_STARTED,
                    payload: member.identity,
                });
            });
            // Listen for members typing
            channel.on('typingEnded', function (member) {
                dispatch({
                    type: Types.TYPING_ENDED,
                    payload: member.identity,
                });
            });
        }
    }, [members, channel]);
    useEffect(function () {
        // Subscribe to each member's online status
        channelMembers.forEach(function (member) {
            var getUserAsync = function () { return __awaiter(_this, void 0, void 0, function () {
                var user;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, member.getUser()];
                        case 1:
                            user = _a.sent();
                            // Register User updated event handler (online/offline)
                            user.on('updated', function (update) {
                                var user = update.user;
                                // loop over each reason and check for reachability change
                                update.updateReasons.forEach(function (reason) {
                                    if (reason === 'online') {
                                        var updatedLendiMembers = __spreadArray([], members, true); // 1. Make a shallow copy of the items
                                        var memberIndex = members.findIndex(function (member) { return member.identity === user.identity; });
                                        if (memberIndex !== -1) {
                                            var updatedLendiMember = __assign(__assign({}, members[memberIndex]), { isOnline: !!user.isOnline });
                                            updatedLendiMembers[memberIndex] = updatedLendiMember; // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
                                            dispatch({
                                                type: Types.UPDATE_MEMBERS,
                                                payload: updatedLendiMembers,
                                            });
                                        }
                                    }
                                    else {
                                        // console.log('userMember: User ', user, ' updated because: ', reason);
                                    }
                                });
                            });
                            return [2 /*return*/];
                    }
                });
            }); };
            getUserAsync();
        });
    }, [members]);
    // Whenever members array changes, meaning
    // - members are 1st retrieved and updated, or
    // - new member joined, or
    // - existing member updated lastConsumedMessageIndex)
    // - existing member updated onlineState
    // We update each message if applicable
    useEffect(function () {
        var updatedMessages = messages.map(function (message) { return parseLendiMessage(message, members); });
        dispatch({
            type: Types.UPDATE_MESSAGES,
            payload: updatedMessages,
        });
    }, [members]);
}
//# sourceMappingURL=index.js.map